<div class="w-full px-2 sm:px-[10%] mt-[50px]">
    <div class="w-full flex flex-wrap justify-center gap-6">
        <div *ngFor="let info of cardInfo" class="w-[400px] items-center">
            <app-card [info]="info"></app-card>
        </div>
    </div>
</div>